import PropTypes from 'prop-types';

import { useDesignContext } from '@febos-io/design/src/providers';

import { useCompanyByIdEffect } from '../hooks';

export function Company(
  {
    id
  }
) {
  const { Loader } = useDesignContext();
  const {
    loading,
    element
  } = useCompanyByIdEffect(id);
  return (
    <div className="d-flex flex-column justify-content-between flex-grow-1">
      <div className="row gx-2">
        {loading ? (
          <Loader />
        ) : (
          <>
            <p>
              Identification Number:
              {element.identificationNumber}
            </p>
            <p>
              Business Name:
              {element.businessName}
            </p>
            <p>
              Date:
              {element.createAt}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default Company;

Company.propTypes = {
  id: PropTypes.elementType.isRequired
};
